import { FiArrowRight } from "react-icons/fi";
import { ALERT_SEVERITIES } from "../../../utils/alertCategories";
import AlertCategoryIcon from "./AlertCategoryIcon";
import getSeverityStyles from "./alertSeverityStyles";

/**
 * Molekül: tek uyarı kategorisinin kartı. Tıklanınca listesi (AlertDrawer)
 * açılır; sayısı 0 ise "Sorun yok" der, tıklanmaz, ikonu hareketsizdir.
 *
 * @param {{ category: object, onOpen: (category) => void, index?: number }} props
 */
export default function AlertCategoryCard({ category, onOpen, index = 0 }) {
  const { label, description, count, severity, iconKey } = category;
  const isClear = count === 0;
  const styles = getSeverityStyles(severity, isClear);

  return (
    <button
      type="button"
      disabled={isClear}
      onClick={() => onOpen(category)}
      style={{ animationDelay: `${index * 60}ms` }}
      className={`group relative flex flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white p-4 text-left shadow-sm transition-all duration-300 motion-safe:animate-cardRise ${
        isClear
          ? "cursor-default"
          : `hover:-translate-y-0.5 hover:border-gray-300 hover:shadow-lg ${styles.glow} focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400`
      }`}
    >
      {/* Üst renk şeridi — önem derecesi */}
      <span
        aria-hidden="true"
        className={`absolute inset-x-0 top-0 h-1 bg-gradient-to-r ${styles.accent}`}
      />

      <div className="flex items-start justify-between gap-3">
        <AlertCategoryIcon iconKey={iconKey} severity={severity} isClear={isClear} />
        <span
          className={`rounded-full px-2 py-0.5 text-[11px] font-SemiBold ring-1 ${styles.badge}`}
        >
          {isClear ? "Sorun yok" : ALERT_SEVERITIES[severity]?.label}
        </span>
      </div>

      <div className="mt-4 flex items-baseline gap-2">
        <span className={`text-3xl font-Bold tabular-nums leading-none ${styles.count}`}>
          {count}
        </span>
        <span className="text-sm font-SemiBold text-gray-800">{label}</span>
      </div>
      <p className="mt-1.5 text-xs text-gray-500">{description}</p>

      {!isClear && (
        <span className="mt-4 inline-flex items-center gap-1.5 text-xs font-Medium text-indigo-600">
          Listeyi aç
          <FiArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" />
        </span>
      )}
    </button>
  );
}
